<template>
<div>
  <header class="sticky-top mb-5">
    <nav class="navbar navbar-expand-md navbar-light bg-white shadow">
      <div class="container-fluid">
      <router-link class="navbar-brand" to="/">
        <img src="./assets/FCCP-logo.png" width="350" height="120" alt="Logo">
      </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-spacing" id="">
          <ul class="navbar-nav ms-auto me-auto mb-2 mb-md-0">
            <li class="nav-item">
              <router-link class="nav-link"  to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/about">About</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/resources">Resources</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/support">Support</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
    <router-view/>

  <hr class="featurette-divider">
  <footer class="container">
    <p class="float-end"><a href="#">Back to top</a></p>
    <p>&copy; 2021-{{current_date}} Sylva Foundation &middot; <a href="#">Privacy</a> &middot; <a href="#">Terms</a></p>
  </footer>
</div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      current_date: ''
    }
  },
  async mounted() {
    let date = new Date().getFullYear()
    this.current_date = date
  }
}
</script>

<style scoped>
</style>
